export const ADVISER_STATUS_OPTIONS = ["FP", "MA", "GI/Prot", "NAP"].map(value => ({ label: value, value }));
export const getAdviserBusinessStatus = (adviser = {}) => {
  const status = String(
    adviser.status || adviser.adviserStatus || adviser.businessStatus || "",
  )
    .trim()
    .toLowerCase();

  const isFp =
    /\bfp\b/.test(status) ||
    status.includes("financial planning") ||
    status.includes("financial planner");

  if (isFp) {
    return "FP";
  }

  const isGiProt =
    status.includes("gi/prot") ||
    status.includes("gi prot") ||
    /\bgi\b/.test(status) ||
    status.includes("general insurance");

  if (isGiProt) {
    return "GI/Prot";
  }

  const isMa =
    /\bma\b/.test(status) ||
    status.includes("mortgage") ||
    status.includes("mortgages");

  if (isMa) {
    return "MA";
  }

  const isNap = /\bnap\b/.test(status) || status.includes("not appointed");

  if (isNap) {
    return "NAP";
  }

  return "";
};

